import { useTheme } from "@outschool/backpack";
import { useTranslation } from "@outschool/localization";
import { useSession } from "@outschool/ui-auth";
import { Select } from "@outschool/ui-legacy-component-library";
import React from "react";

import ActionType from "../../actions/ActionType";
import { useUpdateCurrentUserMutation } from "../../queries/CurrentUser";
import { useAppState } from "../../stores/AppStateProvider";

export function PrivacyStateSelect() {
  const { isLoggedIn, currentUser } = useSession();
  const appState = useAppState();
  const [updateCurrentUser] = useUpdateCurrentUserMutation();
  const { t } = useTranslation("client\\routes\\ParentProfile");
  const theme = useTheme();
  const [updatingUser, setUpdatingUser] = React.useState(false);

  const updateUser = async (field: $TSFixMe, value: $TSFixMe) => {
    setUpdatingUser(true);
    const { data } = await updateCurrentUser({
      variables: { [field]: value }
    });
    if (data?.updateCurrentUser) {
      appState.appDispatcher.dispatch(ActionType.User.CURRENT_USER_UPDATED, {
        currentUser: data.updateCurrentUser,
        property: field
      });
    }
    setUpdatingUser(false);
  };

  if (!isLoggedIn || !currentUser || !currentUser.privacy_state) {
    return null;
  }

  const ANYONE_LABEL = t("Anyone visiting Outschool (public)");
  const PRIVATE_LINK_LABEL = t("Anyone with my private profile link");
  const ONLY_ME_LABEL = t("Only me (profile sharing disabled)");
  const ANYONE_VALUE = "anyone";
  const PRIVATE_LINK_VALUE = "private link";
  const ONLY_ME_VALUE = "only me";

  const answerMap = {
    [PRIVATE_LINK_VALUE]: PRIVATE_LINK_LABEL,
    [ANYONE_VALUE]: ANYONE_LABEL,
    [ONLY_ME_VALUE]: ONLY_ME_LABEL
  };
  const reverseAnswerMap = {
    [PRIVATE_LINK_LABEL]: PRIVATE_LINK_VALUE,
    [ANYONE_LABEL]: ANYONE_VALUE,
    [ONLY_ME_LABEL]: ONLY_ME_VALUE
  };

  return (
    <Select
      name="profileVisibility"
      id="profileVisibilitySelect"
      options={[
        answerMap["private link"],
        answerMap["anyone"],
        answerMap["only me"]
      ]}
      // @ts-ignore
      value={answerMap[currentUser.privacy_state]}
      onChange={(val: string) => {
        updateUser("privacy_state", reverseAnswerMap[val]);
      }}
      disabled={updatingUser}
      sx={{
        width: "100%",
        color: theme.palette.grey[900],
        borderColor: theme.palette.grey[300],
        select: {
          fontSize: "1.3rem",
          ["@media (max-width: 1075px)"]: {
            textAlign: "center"
          }
        }
      }}
    />
  );
}
